import { MDBCard, MDBCardBody, MDBCardHeader, MDBRow, MDBCol, MDBCardImage } from "mdb-react-ui-kit";
// import React from "react";

interface staff_list {
    img: string
    name: string
    position: string
    body: Array<string>
}

export function OurStaff() {

    const our_staff_list: Array<staff_list> = [
        {
            img: '../../../our_staff_pics/staff_1.jpeg',
            name: 'Daniel Nyadanu',
            position: 'Coodinator',
            body: [
                'Holds BSc Agriculture Science, MPhil (Crop Science), PhD ( Genetics and Plant Breeding), MBA (Project Management), Post-graduate diploma (Teaching and learning in higher education), Senior  Research Scientist of Cocoa Research Institute of Ghana since 2017; has more than 15 years of research, lecturing, training in the fields of  Agronomy, Plant Breeding, Genetics,  Molecular Biology, Germplasm Management, Seed Science and Technology, Neglected and underutilized species, Project Management, Research Methods and Value chain analysis.',
                'Daniel has been involved in projects for sustainable supply of NUS crops or opportunity crops to Ghana Food Movement; Cultivation and development of out-grower scheme for production of tropical almond (Terminalia catappa) for Talmond limited; and Piloting of Community Seed Banks in Ghana supported by Netherlands Embassy in collaboration with Bioversity International.'
            ]
        },
        {
            img: '../../../our_staff_pics/staff_2.jpeg',
            name: 'Dr. Richard Adu Amoah',
            position: 'Research Scientist',
            body: [
                'Holds Ph.D. in Plant Breeding, M.Phil in Plant Breeding and a B.Sc. in Agriculture from the Kwame Nkrumah University of Science and Technology, Kumasi, Ghana. Research Scientist, Plant Genetic Resources Research Institute, CSIR, Ghana.',
                 'He is passionate about and committed to agricultural research aimed at enhancing crop performance under changing climatic conditions.',
                 'He has more than 10 years of diverse experience, and insightful knowledge of agricultural biodiversity, plant breeding, genetics, crop germplasm collection, neglected and underutilized species, research methods, assessment of genetic diversity as well as application of conventional breeding and advanced molecular tools to improve the performance and productivity of crops.'
            ]
        },
        {
            img: '../../../our_staff_pics/staff_3.jpeg',
            name: 'Mr. Prince Pobee',
            position: 'Agronomist',
            body: [
                'Holds MPhil in Agronomy and a B.Sc. in Agriculture from the University of Cape Coast, Cape Coast, Ghana.',
                'He is passionate about Climate Smart Agriculture and dynamic agroforestry.',
                'He is a Research Scientist with the Cocoa Research Institute of Ghana.'
            ]
        },
        {
            img: '../../../our_staff_pics/staff_9.jpeg',
            name: 'Mr. Seth Mesah',
            position: 'Field Assistant',
            body: [
                'Holds a diploma in Agriculture from the Kwadaso Agriculture College Ghana.',
                'He is passionate about agriculture and its relevance to improvement of livelihoods of the rural folk.'
            ]
        },
        {
            img: '../../../our_staff_pics/staff_4.jpeg',
            name: 'Mr. Ernest Amanor-Larbi ',
            position: 'Seed Scientist And Technical Office',
            body: [
                'Holds an MPhil in Seed Science and Technology from the University of Ghana and a BSc in agriculture from the Kwame Nkrumah University of Science and Technology.',
                'He is a Technical Officer and passionate about agro-biodiversity, agronomy, climate-smart crop development and farmer education to optimize their outputs.',
                'He is currently serving as Head of the Plant Protection and Regulatory Unit and an Agricultural Extension Agent at the Department of Agriculture of the Yilo Krobo municipality.',
                'Heis FAO-certified Farmer Field School Facilitator, CABI PlantWise Certified Plant Doctor, and a DAAD scholarship recipient and recognized for excellence as Best Agricultural Extension Agent in 2021'
            ]
        },
        {
            img: '',
            name: 'Godfred Soundara',
            position: 'Technical Office',
            body: [
                'Holds a BSc in Agriculture from University of Education Winneba, Mampong Compus.',
                'He is passionate about agriculture and cultural practices to improve crop growth and yield.',
            ]
        },
        {
            img: '../../../our_staff_pics/staff_7.jpeg',
            name: 'Miss Safura Korkor Sodji',
            position: 'Technical Office',
            body: [
                'Holds HND Post Harvest Technology, BSc Food Science and Technology. She specializes in adding value to under-utilized species, handling, processing and packaging of developed food products.',
                'She is our Secretary and also assist in technical activities especially on value addition projects.',
            ]
        },
        {
            img: '../../../our_staff_pics/staff_8.jpeg',
            name: 'Godsway Yaw Gavoe',
            position: 'Accountant ',
            body: [
                'Is a chartered accountant and responsible for our accounting issues.',
            ]
        },
        {
            img: '../../../our_staff_pics/staff_5.jpeg',
            name: 'Vincent Mensah',
            position: 'Driver ',
            body: [
                'Holds NVTI in auto-mobile engineering.',
            ]
        }
    ]

    return (
        <>
            <MDBCard className={'border border-0 border-danger shadow-5'}>
                <MDBCardHeader>OUR STAFF</MDBCardHeader>
                <MDBCardBody>
                    <MDBRow className={'border border-0 border-danger gy-3'}>
                        {our_staff_list.map(
                            (staff, index) => (
                                <MDBCol key={index} className={'border border-0 border-danger'} lg={4}>
                                    <MDBCard className={'border border-0 border-danger shadow-0'}>
                                        <MDBCardImage style={{ height: '400px' }} src={staff.img !== '' ? `${staff.img}`:'../../../user.png'} alt='...' position='top' />
                                        <MDBCardBody>
                                            <p>
                                                <span className={'fw-bold'}>{staff.name}</span><br />
                                                <span className={'fw-normal'}>{staff.position}</span>
                                            </p>
                                            {staff.body.map(
                                                bdy => <p className={'fw-light'}>{bdy}</p>
                                            )}
                                        </MDBCardBody>
                                    </MDBCard>
                                </MDBCol>
                            )
                        )}
                    </MDBRow>
                </MDBCardBody>
            </MDBCard>
        </>
    )
}